var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconAttachMediaSolid extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconAttachMedia",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M1920 707.04v712.403c-.104 105.76-84.587 191.8-188.376 191.8-103.892 0-188.272-86.143-188.272-192.111 0-105.968 84.38-192.216 188.272-192.216 30.618 0 59.16 8.095 84.588 21.38V846.013l-442.035 130.773v604.048h-.83c-4.359 102.024-86.455 183.809-187.441 183.809-103.893 0-188.376-86.144-188.376-192.216 0-105.864 84.483-192.112 188.376-192.112 30.513 0 58.951 8.095 84.483 21.38V899.256L1920 707.04ZM.208 244.954c704.307-200.207 1350.804.104 1350.804.104v480.54l-201.972 60.716v459.99C527.97 1362.13 0 1199.91 0 1199.91V245.058Zm541.567 235.807v496.004l210.794-124.027 210.898-123.923-210.898-124.13L541.775 480.76Z",
      fillRule: "evenodd"
    })));
  }
}
IconAttachMediaSolid.glyphName = 'attach-media';
IconAttachMediaSolid.variant = 'Solid';
IconAttachMediaSolid.displayName = 'IconAttachMediaSolid';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconAttachMediaSolid.propTypes = {
  ...SVGIcon.propTypes
};
IconAttachMediaSolid.allowedProps = [...SVGIcon.allowedProps];
export default IconAttachMediaSolid;
export { IconAttachMediaSolid };